export const SITE_URL = 'https://heyheatman.com';
export const SOCIAL_IMAGE_URL = `${SITE_URL}/psha.png`;

export const PAGE_SEO = {
  home: {
    path: '/',
    title: 'HVAC Repair South Jordan, UT | Preferred Service',
    description:
      'Local heating, cooling, AC repair, furnace repair, installation, and maintenance in South Jordan and nearby Salt Lake County communities.',
  },
  services: {
    path: '/service',
    title: 'HVAC Services in South Jordan, UT | Preferred Service',
    description:
      'Explore AC and furnace repair, HVAC installation, maintenance, indoor air quality, and ductless service across Salt Lake County.',
  },
  about: {
    path: '/about',
    title: 'About Preferred Service Heating & Air | South Jordan',
    description:
      'Meet the family-owned South Jordan HVAC company serving Salt Lake County since 2003 with straightforward heating and cooling service.',
  },
  contact: {
    path: '/contact',
    title: 'Request HVAC Service in South Jordan, UT | Preferred Service',
    description:
      'Request heating or cooling service from Preferred Service Heating & Air in South Jordan, or call (801) 577-2442 for help.',
  },
};
